import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import MyRolesContent from '../components/pages/user/my-roles/content';

function MyRolesPage(props) {
  const showMyRolesModal = useSelector((state) => state.modalReducer.showMyRolesModal);
  const showOtherUsersRolesModal = useSelector((state) => state.modalReducer.showOtherUsersRolesModal);
  const user = useSelector((state) => state.usersReducer.userProfile);
  const myRoles = useSelector((state) => state.usersReducer.myRoles);
  const hasRolesInOtherNetworks = useSelector((state) => state.usersReducer.hasRolesInOtherNetworks);
  const userName = useSelector(
    (state) => state.usersReducer.userProfile.firstName + ' ' + state.usersReducer.userProfile.lastName
  );

  const deletedRoleIds = useSelector((state) => {
    let deletedRoleIds = [];
    if (state.usersReducer.myRoles) {
      return (deletedRoleIds = state.usersReducer.myRoles
        .filter((myRole) => {
          return myRole.isDeleted == true;
        })
        .map((myRole) => myRole.personNetworkRoleId));
    }
  });

  const dispatch = useDispatch();

  return (
    <div>
      <MyRolesContent
        showMyRolesModal={showMyRolesModal}
        showOtherUsersRolesModal={showOtherUsersRolesModal}
        hasRolesInOtherNetworks={hasRolesInOtherNetworks}
        isViewingOthers={props.isViewingOthers}
        selectedUser={props.selectedUser}
        user={user}
        userName={userName}
        dispatch={dispatch}
        myRoles={myRoles}
        deletedRoleIds={deletedRoleIds}
      />
    </div>
  );
}

export default MyRolesPage;
